import { render } from "./Sandwiches.vue?vue&type=template&id=57f368ca&scoped=true"
import script from "./Sandwiches.vue?vue&type=script&lang=js"
export * from "./Sandwiches.vue?vue&type=script&lang=js"

import "./Sandwiches.vue?vue&type=style&index=0&id=57f368ca&scoped=true&lang=css"

import exportComponent from "/sv-shops-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f368ca"]])

export default __exports__